<!--
 * =====================================================================
 * 작 업 명  : 회원가입
 * 파 일 명  : Join.vue
 * 변경이력
 * 2022-03-10 / 임태민 / 최초작성
 * =====================================================================
 -->
<template>
  <div>
    <div class="text mt-3 mb-5">
      <h4><b>Welcome!</b></h4>
    </div>
    <div class="row">
      <div class="col">
        <div class="">Thanks for creating an account.</div>
      </div>
    </div>
    <div class="row">
      <div class="col mb-3"></div>
      <div class="col mb-3">
        <button type="button" class="btn btn-dark w-100" @click="confirm()">
          OK
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import "@/assets/css/formLayout.css";
import { router } from "@/router/index.js";

export default {
  props: ["fromParams"],
  data() {
    return {};
  },
  methods: {
    confirm() {
      if (window.webkit) {
        window.webkit.messageHandlers.join.postMessage("ok");
      } else {
        let fromParams = this.fromParams;
        router.push({
          path: "/login",
          query: {
            cb: fromParams.cb,
            s: fromParams.s,
            c: fromParams.c,
          },
        });
      }
    },
  },
};
</script>
<style></style>
